export default {"src":"/_next/static/media/pencil-icon.068ddfa2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};